import React from 'react'
import PropTypes from 'prop-types'
import { IconSLIWrapper } from './IconSLIWrapper'

export const IconNotificationOff = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconSLIWrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      <svg preserveAspectRatio='xMidYMid' viewBox='0 0 23.813 23.91'>
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          fillRule='evenodd'
          d='M23.525,1.690 L1.689,23.607 C1.496,23.801 1.242,23.899 0.988,23.899 C0.734,23.899 0.480,23.801 0.286,23.607 C-0.102,23.218 -0.102,22.587 0.286,22.198 L2.767,19.708 C2.535,19.583 2.340,19.406 2.201,19.180 C1.913,18.713 1.905,18.131 2.179,17.581 L4.958,12.677 L4.958,6.962 C4.958,3.117 8.074,-0.011 11.904,-0.011 C14.691,-0.011 17.168,1.659 18.262,4.155 L22.122,0.281 C22.509,-0.109 23.138,-0.109 23.525,0.281 C23.913,0.670 23.913,1.300 23.525,1.690 ZM16.705,5.691 C16.705,5.691 16.705,5.690 16.705,5.690 C16.133,3.507 14.158,1.982 11.904,1.982 C9.168,1.982 6.943,4.216 6.943,6.962 L6.943,12.940 C6.943,12.960 6.933,12.977 6.932,12.996 C6.928,13.062 6.910,13.125 6.893,13.190 C6.875,13.256 6.860,13.319 6.831,13.379 C6.822,13.396 6.823,13.416 6.813,13.433 L4.245,17.962 C4.309,17.981 4.364,18.016 4.422,18.047 L16.710,5.713 C16.708,5.705 16.707,5.698 16.705,5.691 ZM9.164,18.272 C9.353,18.049 9.629,17.921 9.920,17.921 L19.544,17.921 L16.998,13.433 C16.989,13.416 16.989,13.396 16.981,13.379 C16.951,13.319 16.936,13.256 16.919,13.190 C16.902,13.125 16.883,13.062 16.880,12.996 C16.878,12.977 16.868,12.960 16.868,12.940 L16.868,10.947 C16.868,10.398 17.313,9.951 17.861,9.951 C18.409,9.951 18.853,10.398 18.853,10.947 L18.853,12.677 L21.607,17.534 C21.906,18.131 21.898,18.713 21.610,19.180 C21.324,19.646 20.808,19.914 20.196,19.914 L15.876,19.914 C15.876,22.111 14.094,23.899 11.904,23.899 C9.800,23.899 8.060,22.249 7.940,20.142 C7.925,19.887 8.010,19.635 8.175,19.440 L9.164,18.272 ZM11.904,21.906 C13.000,21.906 13.891,21.012 13.891,19.914 L10.379,19.914 L9.976,20.391 C10.189,21.264 10.976,21.906 11.904,21.906 Z'
        />
      </svg>
    </IconSLIWrapper>
  )
}

IconNotificationOff.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
